import {
  Component,
  Input,
  forwardRef,
  Output,
  EventEmitter,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  FormGroup,
  FormBuilder,
} from '@angular/forms';

@Component({
  selector: 'monorepo-select-dropdown',
  templateUrl: './select-dropdown.component.html',
  styleUrls: ['./select-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectDropdownComponent),
      multi: true,
    },
  ],
})
export class SelectDropdownComponent implements ControlValueAccessor {
  form: FormGroup;
  @Input() iconName: any;
  @Input() placeholder: any;
  @Input() options: any;
  @Input() fieldName: string;
  @Input() fieldValue: any;
  @Output() optionChange = new EventEmitter();
  isShowDropDown = false;
  optionList: any = [];
  selectedOption: any;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      value: [''],
    });
    this.optionList = this.options;
    this.iconName = this.iconName === undefined ? 'caret down' : this.iconName;
  }

  onChange: any = () => undefined;
  onTouch: any = () => undefined;

  val = '';

  set value(val: any) {
    if (val !== undefined && this.val !== val) {
      this.val = val;
      this.form.get('value').setValue(val);
      this.onChange(val);
      this.onTouch(val);
    }
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public filterOptions(val: any): void {
    this.isShowDropDown = true;
    this.optionList = this.options.filter((option) =>
      option[this.fieldValue].toLowerCase().includes(val.toLocaleLowerCase())
    );
    if (val === '') {
      this.isShowDropDown = false;
    }
  }

  public onSelectedOption(val: any, option: any): void {
    this.selectedOption = val;
    this.writeValue(val);
    this.optionChange.emit(option);
    this.isShowDropDown = false;
  }

  public openDropDown(): void {
    this.isShowDropDown = true;
    this.optionList = this.options;
  }

  public closeDropDown(): void {
    this.isShowDropDown = false;
  }
}
